import { Component, OnInit } from '@angular/core';
import {AppSettings} from '../../utils/app-settings';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'not-found-page',
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./not-found-page.component.scss']
})
export class NotFoundPageComponent {

  constructor(private _userService: UserService, private _router: Router) { }

  navigateToLoginPage($event) {
    $event.preventDefault();

    if (this._userService.isSsoUser) {
      window.location.href = AppSettings.mmiLoginLink();
      return;
    }

    this._router.navigateByUrl('/login');
  }
}



// WEBPACK FOOTER //
// ./src/app/mmi/not-found-page/not-found-page.component.ts